import CloseIcon from "@mui/icons-material/Close";
import { Alert, Box, Collapse, IconButton, Typography } from "@mui/material";
import React, { useContext, useState } from "react";

import { Colors } from "../../common/colors";
import { CustomerContext } from "../../contexts/customer/CustomerContext";
import { FeatureFlagsContext } from "../../contexts/feature-flags/FeatureFlagsContext";
import { ICustomerStatus, IFeatureFlag } from "../../generated/types";

export const AccountClosureBanner: React.FC = () => {
    const { isFeatureFlagEnabled } = useContext(FeatureFlagsContext);
    const { selectedCustomer } = useContext(CustomerContext);
    const [isDismissed, setIsDismissed] = useState(false);

    const isAccountOpen = selectedCustomer?.status === ICustomerStatus.Open;

    if (!isFeatureFlagEnabled(IFeatureFlag.AccountClosureNotification) || !isAccountOpen) {
        return null;
    }

    const handleClose = () => {
        setIsDismissed(true);
    };

    return (
        <Collapse in={!isDismissed}>
            <Box
                sx={({ zIndex: { modal } }) => ({
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: modal - 1,
                })}
            >
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="error"
                            size="medium"
                            onClick={handleClose}
                            sx={{ marginTop: "-4px" }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{
                        borderRadius: 0,
                        justifyContent: "center",
                        backgroundColor: Colors.Red[50],
                        borderBottomColor: Colors.Red[200],
                        "& .MuiAlert-message": {
                            textAlign: "center",
                            flex: 1,
                        },
                    }}
                >
                    <Typography fontWeight="bold">
                        Levro is sunsetting all accounts and your account will be closed on Saturday, November 15, 2025.
                        Please withdraw all funds prior to this day.
                    </Typography>
                </Alert>
            </Box>
        </Collapse>
    );
};
